import React from "react";
import { Link } from "react-router-dom";

const DeleteModal = (props) => {
  const {
    Name = "Delete",
    confirmDelete = () => {},
    btnName = "Delete",
    onClose = () => {},
  } = props;
  return (
    <>
      <div
        className="modal custom-modal fade"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        id="delete_employee"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{Name}</h3>
                <p>Are you sure want to {Name}?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                    <Link
                      to="#"
                      className="btn btn-primary continue-btn"
                      onClick={confirmDelete}
                      data-bs-dismiss="modal"
                    >
                      {btnName}
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-primary cancel-btn"
                      onClick={onClose}
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};

export default DeleteModal;
